import { View } from "@aws-amplify/ui-react"
import FlagIcon from "@mui/icons-material/Flag"
import { ReactElement } from "react"

import AppTooltip from "../helper/appTooltip"

/**
 * Icon with padding for displaying alert flag on search screen.
 * @returns <AlertFlag />
 */
export const AlertFlag = (): ReactElement => (
    <View
        style={{
            paddingLeft: "8px",
        }}
        testId="alertFlag"
    >
        <AppTooltip title="An alert has been raised on this device">
            <FlagIcon color="warning" />
        </AppTooltip>
    </View>
)

export default AlertFlag
